/**
 * The frame with nothing in it yet: the dark frame, the sidebar's column and
 * the main sheet with its top bar's hairline. It is what a signed-in screen
 * shows until the workspace has answered — from the first paint, because
 * `index.html` carries the same markup before any script runs.
 *
 * Keep the two identical. The handover from the static copy to this one, and
 * from this one to `AppFrame`, must draw nothing new: a load that changes the
 * shape of the screen on its way in is the jerk this exists to prevent. A
 * placeholder row, a spinner or a "Loading…" here would be exactly that.
 */
export function FrameShell() {
  return (
    <div className="h-dvh flex flex-col min-[900px]:flex-row bg-frame p-1.5 min-[900px]:py-2 min-[900px]:pl-0 min-[900px]:pr-2 overflow-hidden">
      <div className="hidden min-[900px]:block flex-none w-[var(--sidebar-width)]" />
      <div className="flex-1 min-w-0 flex flex-col overflow-hidden bg-canvas rounded-2xl shadow-sheet">
        <div className="flex-none h-[52px] border-b border-line" />
      </div>
    </div>
  );
}
